export default "__VITE_ASSET__9b11424c__"